export default __webpack_public_path__ + "static/media/26.794eab26.png";